import {
  mapCodeMetricsToRow,
  type AffiliateRow,
} from "../../Affiliates/affiliatesData";
import type {
  AffiliatePortalCodeRow,
  PromoCodeLinkStatus,
} from "../../../types/affiliates";

// Row shape consumed by the shared `PROMO_CODE_COLUMNS` (operator + portal
// share the same column set so the tables stay visually identical).
export type PortalCodeTableRow = AffiliateRow & {
  linkStatus?: PromoCodeLinkStatus;
  reason?: string;
  appLink?: string;
};

// Maps a `/view` code row into the shared table row shape. The 8 metric
// fields come from the un-gated `metrics` block. If a row arrives without it
// (legacy data / partial rollout), fall back to the legacy top-level
// cpa_amount/sportsbook_pl/casino_ngr floats (same Gold values) so those
// three columns don't silently drop to 0.
export const portalCodeToRow = (
  row: AffiliatePortalCodeRow,
): PortalCodeTableRow => {
  const metrics = mapCodeMetricsToRow(row.metrics);
  if (!row.metrics) {
    metrics.cpaAmount = row.cpa_amount;
    metrics.sportsbookPnl = row.sportsbook_pl ?? 0;
    metrics.casinoNgr = row.casino_ngr ?? 0;
  }
  return {
    key: row.referral_code,
    referralCode: row.referral_code,
    ...metrics,
    status: row.disabled ? "deactivated" : "active",
    linkStatus: row.link_status ?? undefined,
    reason: row.applink_failure_reason ?? undefined,
    appLink: row.appsonair_link_url ?? undefined,
  };
};
